var exports = {
  "A": "x31de4314--13e594--item",
};

module.exports = exports;
